import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form } from '@ant-design/compatible';
import { Drawer, Button, Input, Space, Row, Col, InputNumber, DatePicker } from 'antd';
import { isMobile } from 'react-device-detect';
import BaseSelect from '@/components/Elements/BaseSelect';
import { _newLine, isValidDateForm } from '@/utils/helpers';
import ImageSelector from '@/components/ImageSelector';
import { createCardReleaseTracking, updateCardReleaseTracking } from '@/redux/actions/cardReleaseTrackingActions';
import { fetchActiveCardTypes } from '@/redux/actions/cardTypeActions';
import moment from 'moment';

class CardReleaseTrackingForm extends Component {
    constructor() {
        super();
        this.state = {
            isLoading: false,
            images: null
        };
    }
    componentDidMount() {
        this.props.fetchActiveCardTypes();
    }

    async submit(e) {
        e.preventDefault();
        this.props.form.validateFields(async (err, values) => {
            if (!err) {
                this.setState({ isLoading: true });
                try {
                    const sourceImages = this.state.images === null
                        ? (this.props.currentItem?.images || [])
                        : this.state.images;
                    values.images = sourceImages.map(image => ({
                        manual_id: image.manual_id || image.id,
                        src: image.src || image.originalImage || image.url
                    })).filter(image => image.src);
                    values.release_date = values.release_date ? values.release_date.format("YYYY-MM-DD") : null;

                    if (this.props.currentItem) {
                        await this.props.updateCardReleaseTracking(this.props.currentItem.id, values);
                    } else {
                        await this.props.createCardReleaseTracking(values);
                    }
                    this.props.reloadData();
                    this.onClose();
                } catch (error) {
                    this.setState({ isLoading: false });
                }
            }
        });
    }

    onClose() {
        this.props.onCancel();
        this.props.form.resetFields();
        this.setState({ isLoading: false, images: null });
    }

    handleImageChange = fileList => {
        this.setState({ images: fileList || [] });
    };

    render() {
        var { isLoading } = this.state;
        var {
            visible,
            currentItem,
            activeCardTypes,
            users
        } = this.props;
        const { getFieldDecorator } = this.props.form;

        return (
            <Drawer
                visible={visible}
                title={currentItem ? 'Cập nhật bản ghi' : `Thêm bản ghi`}
                onOk={(e) => this.submit(e)}
                onClose={() => this.onClose()}
                maskClosable={false}
                width={isMobile ? '100%' : '50%'}
                footer={
                    <div style={{ textAlign: 'right', }}>
                        <Space>
                            <Button key="back" onClick={() => this.onClose()}>
                                Huỷ
                            </Button>
                            <Button
                                loading={isLoading}
                                key="submit"
                                type="primary"
                                onClick={(e) => this.submit(e)}
                            >
                                {currentItem ? 'Cập nhật' : "Thêm mới"}
                            </Button>
                        </Space>
                    </div>
                }
            >
                {visible ?
                    <Form layout='vertical'>
                        <Row gutter={16}>
                            <Col xs={24} md={12}>
                                <Form.Item label="Nhân viên">
                                    {getFieldDecorator('staff_id', {
                                        rules: [
                                            {
                                                required: true,
                                                message: "Vui lòng chọn!",
                                            },
                                        ],
                                        initialValue: currentItem ? currentItem.staff_id : null
                                    })(
                                        <BaseSelect
                                            options={users ?? []}
                                            showSearch
                                            optionValue="user_id"
                                            optionLabel="display_name"
                                            placeholder="Chọn nhân viên"
                                            className="w-100"
                                        />
                                    )}
                                </Form.Item>
                            </Col>
                            <Col xs={24} md={12}>
                                <Form.Item label="Loại thẻ">
                                    {getFieldDecorator('card_type_id', {
                                        rules: [
                                            {
                                                required: true,
                                                message: "Vui lòng chọn!",
                                            },
                                        ],
                                        initialValue: currentItem ? currentItem.card_type_id : null
                                    })(
                                        <BaseSelect
                                            options={activeCardTypes ?? []}
                                            showSearch
                                            optionValue="id"
                                            optionLabel="name"
                                            placeholder="Loại thẻ"
                                            className="w-100"
                                        />
                                    )}
                                </Form.Item>
                            </Col>
                            <Col xs={24} md={12}>
                                <Form.Item label="Số lượng thẻ được cấp">
                                    {getFieldDecorator('quantity', {
                                        rules: [
                                            {
                                                required: true,
                                                message: 'Vui lòng chọn!',
                                            },
                                        ],
                                        initialValue: currentItem ? currentItem.quantity : null
                                    })(<InputNumber min={1} precision={0} className='w-100' />)}
                                </Form.Item>
                            </Col>
                            <Col xs={24} md={12}>
                                <Form.Item label="Ngày cấp">
                                    {getFieldDecorator('release_date', {
                                        rules: [
                                            {
                                                required: true,
                                                message: 'Vui lòng chọn!',
                                            },
                                        ],
                                        initialValue: currentItem ? isValidDateForm(currentItem.release_date, false) : moment()
                                    })(
                                        <DatePicker
                                            className='w-100'
                                            format="DD/MM/YYYY"
                                        />
                                    )}
                                </Form.Item>
                            </Col>
                            <Col xs={24} md={24}>
                                <Form.Item label="Mã thẻ được cấp">
                                    {getFieldDecorator('card_number', {
                                        rules: [
                                            {
                                                required: true,
                                                message: 'Vui lòng điền!',
                                            },
                                        ],
                                        initialValue: currentItem ? currentItem.card_number : null
                                    })(<Input.TextArea rows={3} />)}
                                </Form.Item>
                            </Col>
                            <Col xs={24} md={24}>
                                <Form.Item label="Ghi chú">
                                    {getFieldDecorator('note', {
                                        rules: [
                                            {
                                                required: false,
                                                message: "Vui lòng điền!",
                                            },
                                        ],
                                        initialValue: currentItem ? _newLine(currentItem.note) : null
                                    })(
                                        <Input.TextArea rows={3} />
                                    )}
                                </Form.Item>
                            </Col>
                            <Col xs={24} md={24}>
                                <Form.Item label="Ảnh" className='flex-upload'>
                                    <ImageSelector
                                        key={currentItem?.id || 'new'}
                                        multiple
                                        maxCount={30}
                                        uploadText="Chọn ảnh"
                                        defaultFileList={currentItem?.images || []}
                                        onChangeData={this.handleImageChange}
                                    />
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                    : null
                }
            </Drawer>
        )
    }
}

function mapStateToProps(state) {
    return {
        activeCardTypes: state.cardTypeReducer.activeItems,
        users: state.config.users
    }
}

function mapDispatchToProps(dispatch) {
    return {
        createCardReleaseTracking: data => dispatch(createCardReleaseTracking(data)),
        updateCardReleaseTracking: (id, data) => dispatch(updateCardReleaseTracking(id, data)),
        fetchActiveCardTypes: () => dispatch(fetchActiveCardTypes())
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Form.create({ name: 'CardReleaseTrackingForm' })(CardReleaseTrackingForm));
